// extracted by mini-css-extract-plugin
export var container = "_fo-0";
export var content = "_fo-3";
export var customerTitle = "_fo-4";
export var empty = "_fo-5";
export var gray = "_fo-6";
export var header = "_fo-7";
export var info = "_fo-8";
export var loading = "_fo-2";
export var loadingCard = "_fo-9";
export var oneLine = "_fo-a";
export var personName = "_fo-e";
export var pillContainer = "_fo-b";
export var selected = "_fo-1";
export var text = "_fo-c";
export var twoLines = "_fo-d";
export var unread = "_fo-f";
export var unreadIndicator = "_fo-g";